export const STORAGE_CREDENTIALS_FIELD = 'thk_credentials';
export const STORAGE_REMEMBER_ME = 'thk_rmmbr_m';

export const COOKIE_LOGGED_IN = 'thk_lggd-n';
export const GUEST_TOKEN_URL = '/status/';
